import "./style.css"
import { t } from "../../global-components/src/i18nTranslate";
import {  MessageCircleQuestionMark, PencilSparkles, BadgeCheck, Eye, TextAlignStart, Heart } from "lucide-react";

const PremiumUserStep1 = () => {
    return (
        <>
            <div className="content-benefits">
                <div className="benefits">
                    <div>
                        <BadgeCheck name="edit_square" className="icon-benefits"/>
                    </div>
                    <div>
                        {t("premium.benefits.one")}
                    </div>
                </div>
                <div className="benefits">
                    <div>
                        <PencilSparkles name="edit_square" className="icon-benefits"/>
                    </div>
                    <div>
                        {t("premium.benefits.two")}
                    </div>
                </div>
                <div className="benefits">
                    <div>
                        <Eye name="edit_square" className="icon-benefits"/>
                    </div>
                    <div>
                        {t("premium.benefits.four")}
                    </div>
                </div>
                <div className="benefits">
                    <div>
                        <TextAlignStart name="search" className="icon-benefits"/>
                    </div>
                    <div>
                        {t("premium.benefits.three")}
                    </div>
                </div>
                <div className="benefits">
                    <div>
                        <Heart name="notifications" className="icon-benefits"/>
                    </div>
                    <div>
                        {t("premium.benefits.six")}
                    </div>
                </div>
                <div className="benefits">
                    <div>
                        <MessageCircleQuestionMark name="headphones" className="icon-benefits"/>
                    </div>
                    <div>
                        {t("premium.benefits.five")}
                    </div>
                </div>

                <div className="space-button"></div>
            </div>
        </>
    );
};

export default PremiumUserStep1;